import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/receipt', component: () => import('@/views/receipt/index'), hidden: true },
  { path: '/receipt.html', component: () => import('@/views/receipt/html'), hidden: true },
  { path: '/interview/interviewShow', component: () => import('@/views/recruit/interview/show'), hidden: true },
  {
    path: '/help', component: () => import('@/views/help/index'), hidden: true, name: 'help'
  },
  {
    path: '/FAQ', component: () => import('@/views/FAQ/index'), hidden: true, name: 'FAQ'
  },
  {
    path: '/faqDetail', component: () => import('@/views/FAQ/faqDetail'), hidden: true, name: 'faqDetail'
  },
  {
    path: '/cateInfo/*', component: () => import('@/views/cms/article/index'), hidden: true, name: 'article'
  },
  { path: '/do404', component: () => import('@/views/404'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'home' }
    }]
  },
]

export const asyncRouterMap = [
  {
    path: '/recruit',
    component: Layout,
    redirect: '/recruit',
    name: 'recruit',
    meta: { title: '公开招聘', icon: 'plan' },
    children: [
      {
        path: 'plan',
        name: 'plan',
        component: () => import('@/views/recruit/plan/index'),
        meta: { title: '公开招聘', icon: 'plan' }
      },
      {
        path: 'positions',
        name: 'positions',
        component: () => import('@/views/recruit/positions/index'),
        meta: { title: '招聘岗位信息' },
        hidden: true,
        display: true
      },
      {
        path: 'applicantsIndex',
        name: 'applicantsIndex',
        component: () => import('@/views/recruit/applicants/index'),
        meta: { title: '个人简历' },
        hidden: true,
        display: false
      },
      {
        path: 'applicantsInfo',
        name: 'applicantsInfo',
        component: () => import('@/views/recruit/applicants/info'),
        meta: { title: '资格审查结果' },
        hidden: true,
        display: true
      },
      /*       {
              path: 'applicantsCheck',
              name: 'applicantsCheck',
              component: () => import('@/views/recruit/applicants/check'),
              meta: { title: '资格审查' },
              hidden: true,
              display: true
            }, */
      {
        path: 'pay',
        name: 'pay',
        component: () => import('@/views/recruit/pay/index'),
        meta: { title: '报名缴费' },
        hidden: true,
        display: true
      },
      {
        path: 'admission',
        name: 'admission',
        component: () => import('@/views/recruit/admission/index'),
        meta: { title: '准考证打印' },
        hidden: true,
        display: true
      },
      {
        path: 'results',
        name: 'results',
        component: () => import('@/views/recruit/results/index'),
        meta: { title: '成绩查询' },
        hidden: true,
        display: true
      },
      {
        path: 'hire',
        name: 'hire',
        component: () => import('@/views/recruit/hire/index'),
        meta: { title: '录用考核' },
        hidden: true,
        display: true
      },
      {
        path: 'bespeak',
        name: 'bespeak',
        component: () => import('@/views/recruit/bespeak/index'),
        meta: { title: '预约报到' },
        hidden: true,
        display: true
      },
      {
        path: 'interview',
        name: 'interview',
        component: () => import('@/views/recruit/interview/index'),
        meta: { title: '线上面试' },
        hidden: true
      },
      {
        path: 'bespeaksuccess',
        name: 'bespeaksuccess',
        component: () => import('@/views/recruit/bespeak/success'),
        meta: { title: '预约成功' },
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: { title: '修改菜单' },
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: { title: '资源列表', icon: 'ums-resource' }
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: { title: '资源分类' },
      },
      {
        path: 'appraisal',
        name: 'appraisal',
        component: () => import('@/views/appraisal/index'),
        meta: { title: '拟聘人员情况报告' },
        hidden: true,
        display: true
      },
      // {

      //   path: 'appraisal',
      //   name: 'appraisal',
      //   component: () => import('@/views/appraisal/index'),
      //   meta: { title: '拟聘人员情况报告' },
      // }
    ]
  }, {
    path: '/notice',
    component: Layout,
    redirect: '/notice',
    name: 'notice',
    meta: { title: '通知公告', icon: 'notice' },
    children: [
      {
        path: 'notice',
        name: 'notice',
        component: () => import('@/views/notice/index'),
        meta: { title: '通知公告', icon: 'notice' }
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]


export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js